export const EVENT_FEEDBACK_HIGHLIGHT = Object.freeze({
  THE_CONVERSATIONS: 'THE_CONVERSATIONS',
  THE_PEOPLE: 'THE_PEOPLE',
  THE_VENUE: 'THE_VENUE',
  THE_FOOD: 'THE_FOOD',
  A_SPECIFIC_CONNECTION: 'A_SPECIFIC_CONNECTION',
});

export const EVENT_FEEDBACK_HIGHLIGHT_LABELS = Object.freeze({
  [EVENT_FEEDBACK_HIGHLIGHT.THE_CONVERSATIONS]: 'The conversations',
  [EVENT_FEEDBACK_HIGHLIGHT.THE_PEOPLE]: 'The people',
  [EVENT_FEEDBACK_HIGHLIGHT.THE_VENUE]: 'The venue',
  [EVENT_FEEDBACK_HIGHLIGHT.THE_FOOD]: 'The food',
  [EVENT_FEEDBACK_HIGHLIGHT.A_SPECIFIC_CONNECTION]: 'A specific connection',
});

export const getEventFeedbackHighlightLabel = (highlight) => {
  const key = String(highlight || '')
    .trim()
    .toUpperCase();
  if (!key) return null;
  return EVENT_FEEDBACK_HIGHLIGHT_LABELS[key] ?? null;
};

export const formatEventFeedbackTableMatchScore = (value) => {
  if (value == null || value === '') return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return `${Math.round(numeric)}%`;
};
